var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartLayout',{attrs:{"title":_vm.title,"half":_vm.half}},[_c('DataGetter',{attrs:{"url":_vm.apiRoute,"params":_vm.params},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('DataSlicer',{staticClass:"exit-chart",attrs:{"data":data,"x-axis-dimension":"country","y-axis-dimension":"techSector","value-dimension":"value","no-single-value":""},scopedSlots:_vm._u([{key:"default",fn:function({ slicedData }){return [_c('footer',{staticClass:"m-chart__footer"},[_c('ChartLegend',{attrs:{"legend-items":[
              { name: _vm.low, colorIndex: 5 },
              { name: _vm.high, colorIndex: 1 },
            ]}})],1),_c('Chart',{attrs:{"options":{
            ..._vm.chartOptions,
            series: _vm.formatSeries(slicedData),
          }}})]}}],null,true)})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }